import { PromoTitle, PromoDescription, PromoCard, PromoSkillsShowCase, PromoTeachEnglish, PromoMotto, PromoInterested, PromoThingsISupport } from "../components/C_Promo";
import { VideoElement } from "../components/C_Video";
import { Template, PromoFunctions, HorizontalMiddleMouseScroll, ScrollRevealAction, colorfulBannerName } from "../utils/helper";
import { PromoParts, Banner } from "../static";
import posts from '../assets/json/posts.json';
import skills from '../assets/json/promo_Skills.json';
import Localize from "../utils/initLocalization";
import ThreeJs from "../services/threeJs";
class Promo extends HTMLElement {
    hmmsCleanupFunctions = [];
    promoTabCleanup = null;
    constructor() {
        super();
        new Template().createTemplate(new PromoTemplate().promoTemplate(), this);
    }
    handleThreeJsAnimation() {
        const scene = new ThreeJs("#threeJsAnimationContainer");
        scene.loadModel("../assets/3d/desk.glb");
    }
    handlePromoElements() {
        const promoFunctions = new PromoFunctions();
        promoFunctions.createPromoContent("#promoCardContainer", posts, (post) => new PromoCard().renderPromoCard(post));
        promoFunctions.createPromoContent("#promoSkillsContainer", skills, (skill) => new PromoSkillsShowCase().renderPromoSkillsShowCase(skill));
        this.promoTabCleanup = promoFunctions.bindVerticalTabEventsAndautoCycleTabs(new PromoParts().promoTabData);
    }
    handleMiddleMouseScroll() {
        this.hmmsCleanupFunctions.push(new HorizontalMiddleMouseScroll().hmmsScroll(".promo-featured-tabs"));
        this.hmmsCleanupFunctions.push(new HorizontalMiddleMouseScroll().hmmsScroll(".promo-card-container"));
    }
    handleDynamicDivs() {
        const dynamicContentDivs = ["promo-videos-container",
            "promo-desc-container",
            "promo-skills-container",
            "promo-projects-container",
            "promo-motto-container",
            "promo-teacheng-container",
            "promo-interested-container"];
        new ScrollRevealAction().scrollReveal(dynamicContentDivs);
    }
    handleColorfulBannerName() {
        colorfulBannerName(Banner.BANNER_ASCII, "homePageNameBannerCode");
    }
    connectedCallback() {
        this.handlePromoElements();
        this.handleMiddleMouseScroll();
        this.handleDynamicDivs();
        this.handleColorfulBannerName();
        this.handleThreeJsAnimation();
    }
    disconnectedCallback() {
        this.hmmsCleanupFunctions.forEach(cleanup => cleanup());
        this.hmmsCleanupFunctions = [];
        if (this.promoTabCleanup) {
            this.promoTabCleanup();
            this.promoTabCleanup = null;
        }
    }
}
class PromoTemplate {
    videoOne = new VideoElement({
        title: Localize.translate("common:video:teach"),
        webmSrc: "../assets/videos/teach.webm",
        posterSrc: "../assets/videos/poster/teach.jpeg"
    });
    videoTwo = new VideoElement({
        title: Localize.translate("common:video:code"),
        webmSrc: "../assets/videos/code.webm",
        posterSrc: "../assets/videos/poster/code.jpeg"
    });
    promoTemplate() {
        return `
            <section id="promo" class="mx-2 my-2 rounded-5">
                <div class="container-fluid w-100 px-2 py-2 d-flex flex-column gap-4">
                    <div class="promo-videos-container row col-12 mx-auto d-flex flex-row gap-3 align-items-center justify-content-center">
                        ${this.promoVideos()}
                    </div>
                    <div class="promo-desc-container row col-12 mx-auto d-flex flex-column gap-2 align-items-center justify-content-center">
                        ${this.promoDesc()}
                    </div>
                    <div class="promo-skills-container row col-12 mx-auto d-flex flex-column gap-4 align-items-center justify-content-center overflow-hidden">
                        ${this.promoSkills()}
                        <div class="psc-container w-100 position-relative overflow-hidden rounded-5">
                            <div id="promoSkillsContainer" class="d-flex flex-row align-items-center justify-content-center gap-4 py-3"></div>
                        </div>
                    </div>
                    <div class="promo-projects-container-parent">
                        <div class="mb-4">
                            ${new PromoTitle(Localize.translate("common:projects:title"))}
                        </div>
                        <div class="promo-projects-container row col-12 mx-auto d-flex flex-column gap-2 align-items-center justify-content-center overflow-hidden">
                            ${this.promoProjectCards()}
                        </div>
                    </div>
                    <div class="promo-teacheng-container row mx-auto col-12 d-flex flex-column gap-2 align-items-center justify-content-center">
                        ${this.promoEngTeach()}
                    </div>
                    <div class="promo-motto-container row col-12 mx-auto d-flex flex-column gap-2 align-items-center justify-content-center">
                        ${this.promoMotto()}
                    </div>
                    <div class="promo-work-container row col-12 mx-auto d-flex flex-column gap-2 align-items-center justify-content-center">
                        ${this.promoWork()}
                    </div>
                    <div class="promo-animation-container row col-12 mx-auto d-flex flex-column gap-2 align-items-center justify-content-center">
                        ${this.threeJsAnimationContainer()}
                    </div>
                    <div class="promo-support-container-parent">
                        <div>${new PromoTitle(Localize.translate("common:support:title") + "*")}</div>
                        <div class="promo-support-container row col-12 mx-auto d-flex flex-column gap-2 align-items-center justify-content-center rounded-5">
                            ${this.thingsISupport()}
                            <span class="text-center text-italic mb-3">*:${Localize.translate("common:support:supportMsg")}</span>
                        </div>
                    </div>
                    <div class="promo-banner-container row col-12 mx-auto d-flex flex-column gap-2 align-items-center justify-content-center">
                        ${this.promoBanner()}
                    </div>
                </div>
            </section>
        `;
    }
    promoSkills() {
        return `
            ${new PromoTitle(Localize.translate("common:skills:title"))}
        `;
    }
    promoProjectCards() {
        return `
            <div class="promo-scrollable">
                <div id="promoCardContainer" class="promo-card-container d-flex flex-wrap gap-3 justify-content-center"></div>
            </div>
        `;
    }
    promoVideos() {
        return `
            <div class="col-sm overflow-hidden px-1">${this.videoOne.render(Localize.translate("common:video:teach"))}</div>
            <div class="col-sm overflow-hidden px-1">${this.videoTwo.render(Localize.translate("common:video:code"))}</div>
        `;
    }
    promoDesc() {
        return `
            ${new PromoTitle(Localize.translate("common:desc:descTitle"))}
            <div id="promo_Description" class="w-100 d-flex flex-row align-items-center justify-content-evenly overflow-hidden">
                ${new PromoDescription().renderPromoDesc()}
            </div>
        `;
    }
    promoEngTeach() {
        return `
            ${new PromoTitle(Localize.translate("common:teach:title"))}
            <div id="promoTE" class="container-fluid w-100 px-4 py-4 my-4 d-flex flex-row gap-2">
                ${new PromoTeachEnglish().render()}
            </div>
        `;
    }
    promoMotto() {
        return `
            ${new PromoTitle(Localize.translate("common:quoteAboutEdu:title"))}
            <div class="promo-motto-base w-100">
                ${new PromoMotto().render()}
            </div>
        `;
    }
    promoWork() {
        return `
            ${new PromoTitle(Localize.translate("common:work:title"))}
            <div id="promoWork">
                ${new PromoInterested().render()}
            </div>
        `;
    }
    promoBanner() {
        return `
            <pre id="homePageNameBanner">
                <code id="homePageNameBannerCode" class="d-flex justify-content-center align-items-center"></code>
            </pre>
        `;
    }
    threeJsAnimationContainer() {
        return `
            <div id="threeJsAnimationContainer" class="px-3 rounded-5">
            </div>
        `;
    }
    thingsISupport() {
        return `
            <div id="thingsISupportDiv">
                ${new PromoThingsISupport().render()}
            </div>
        `;
    }
}
export default Promo;
customElements.define("app-promo", Promo);
